export const TestPlanStatuses = {
  Draft: 'Draft',
  InReview: 'In Review',
  Approved: 'Approved',
  Archived: 'Archived',
} as const

export const testPlanStatusFilterOptions = Object.values(TestPlanStatuses).map((status) => ({
  value: status,
  label: status,
}))

export function getTestPlanStatusLabel(status: string): string {
  return (TestPlanStatuses as Record<string, string>)[status] ?? status
}

export interface TestSuite {
  id: string
  testSuiteIdentifier: string
  title: string
  testCaseCount: number
}

export interface TestSuiteDetails {
  id: string
  testSuiteIdentifier: string
  title: string
  testCaseCount: number
  testPlanId: string
  testPlanIdentifier: string
  testPlanTitle: string
}

export interface TestPlan {
  id: string
  testPlanIdentifier: string
  title: string
  status: string
  createdByUserId: string | null
  createdByUserName: string | null
  createdByUserEmail: string | null
  testSuites: TestSuite[]
}

export type TestPlanSortColumn = 'number' | 'title' | 'status' | 'user'

export const TEST_PLAN_DEFAULT_SORT_DIRECTIONS: Record<TestPlanSortColumn, 'asc' | 'desc'> = {
  number: 'desc',
  title: 'asc',
  status: 'asc',
  user: 'asc',
}

export interface TestPlanFilters {
  search?: string
  statuses?: string[]
  sortBy?: TestPlanSortColumn
  sortDirection?: 'asc' | 'desc'
}

export interface CreateTestPlanRequest {
  title: string
}

export interface CreateTestPlanResponse {
  testPlanId: string
}

export interface CreateTestSuitesRequest {
  titles: string[]
}

export interface CreatedTestSuiteItem {
  id: string
  testSuiteIdentifier: string
  title: string
}

export interface CreateTestSuitesResponse {
  createdTestSuites: CreatedTestSuiteItem[]
}
